import { useMemo } from 'react'
import { useWatch, type Control, type FieldValues } from 'react-hook-form'
import { useInitiativeAutoSave } from './useInitiativeAutoSave'

/**
 * Debounced `edit-initiative` from current RHF values; `watchDeps` should list
 * watched fields so the autosave payload is referentially stable when unchanged.
 */
export const useInitiativeFormWatchAutosave = <
  TFieldValues extends FieldValues,
>({
  initiativeId,
  control,
  toPayload,
  watchDeps,
}: {
  initiativeId: number
  control: Control<TFieldValues>
  toPayload: (values: TFieldValues) => Record<string, unknown>
  watchDeps: (values: TFieldValues) => readonly unknown[]
}): void => {
  const values = useWatch({ control }) as TFieldValues
  const payload = useMemo(
    () => toPayload(values),
    // eslint-disable-next-line react-hooks/exhaustive-deps -- watchDeps(values) expands to field-level deps
    watchDeps(values),
  )
  useInitiativeAutoSave(initiativeId, payload)
}
